import React from 'react';
import { Combo } from 'fw/forms';

class AnnualRevenueYearCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }

    componentDidMount = () => {
        this._isMounted = true;

        const currentYear = new Date().getFullYear() + 3;
        let yearBusinessFormed = this.props.yearBusinessFormed;

        var years = [];

        for (let year = currentYear; yearBusinessFormed <= year; year--) {
            years.push({ value: year, label: year });
        }

        this.setState({ items: years });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <Combo
                {...this.props}
                items={this.state.items}
                searchable={false}
                ref={(c) => { this._ctrl = c }} />
        )
    }
}

export default AnnualRevenueYearCombo;

// Mark this as a form component
AnnualRevenueYearCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/annualRevenueYearCombo/AnnualRevenueYearCombo.js